import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import Content from "../Modulos/AtendimentoAmb/Home/Content";
import ModalNovoAtendimento from "../Modulos/AtendimentoAmb/Home/ModalNovoAtendimento";
import { useModal } from "../contexts/ModalContext";

const AtendimentoAmb = () => {

    const { openModal, closeModal, isModalOpen } = useModal();

    const openSidebar = () => openModal("atendimentoAmbSidebar");

    const openNovoAtendimento = () => {
        closeModal();
        openModal("atendimentoAmbNovo");
    };

    return (
        <>
            <NavBar
                title="ATENDIMENTO AMBULATORIAL"
                goBackOnePage
                setSideBar={openSidebar}
            />
            <GenericBody>
                <Content />
            </GenericBody>

            {isModalOpen("atendimentoAmbSidebar") && (
                <Overlay state changeContent={closeModal}>
                    <SideMenu>
                        <SideMenuBtn button="NOVO ATENDIMENTO" clickFunc={openNovoAtendimento} />
                    </SideMenu>
                </Overlay>
            )}

            {isModalOpen("atendimentoAmbNovo") && <ModalNovoAtendimento />}
        </>
    );
};

export default AtendimentoAmb;
